import {
  FeatureName,
  QuickConfirmConfig,
  QuickConfirmState,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { string, object as yupObject } from 'yup';
import { useFormContext } from '../../forms';
import { RoutineExecutionForm, RoutineExecutionFormProps } from '../types';
import { QuickConfirmExecutionComponent } from './quickConfirmExecutionComponent';

export const getExecutionFormResolver = () => {
  const validationSchema = yupObject({
    confirmedValue: string().required().nonNullable(),
  });

  return yupResolver(validationSchema);
};

export const getExecutionFormDefaultValues = (
  _: QuickConfirmConfig,
  state?: QuickConfirmState
) => {
  return {
    confirmedValue: state?.confirmedValue,
  };
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const QuickConfirmExecutionFormOld: RoutineExecutionForm<
  QuickConfirmConfig,
  QuickConfirmState
> = (
  props: RoutineExecutionFormProps<QuickConfirmConfig, QuickConfirmState>
) => {
  const formKey = 'confirmedValue';
  const { setValue, watch } = useFormContext();
  const currentConfirmedValue = watch(formKey);

  useEffect(() => {
    if (props.config.options.length === 1) {
      setTimeout(() => {
        onConfirmedValueChanged(props.config.options[0]);
      }, 10);
    }
  }, []);

  const onConfirmedValueChanged = (value: string) => {
    setValue(formKey, value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <QuickConfirmExecutionComponent
      options={props.config.options}
      confirmedValue={currentConfirmedValue}
      onChange={onConfirmedValueChanged}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to QuickConfirmExecutionFormBase after feature is fully rolled out
const QuickConfirmExecutionFormBase: RoutineExecutionForm<
  QuickConfirmConfig,
  QuickConfirmState
> = (
  props: RoutineExecutionFormProps<QuickConfirmConfig, QuickConfirmState>
) => {
  const formKey = 'confirmedValue';
  const { setValue, watch } = useFormContext();
  const currentConfirmedValue = watch(formKey);

  useEffect(() => {
    if (props.config.options.length === 1) {
      setTimeout(() => {
        onConfirmedValueChanged(props.config.options[0]);
      }, 10);
    }
  }, []);

  const onConfirmedValueChanged = (value: string) => {
    setValue(formKey, value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <QuickConfirmExecutionComponent
      options={props.config.options}
      confirmedValue={currentConfirmedValue}
      onChange={onConfirmedValueChanged}
      useCropCircle
    />
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const QuickConfirmExecutionForm: RoutineExecutionForm<
  QuickConfirmConfig,
  QuickConfirmState
> = (
  props: RoutineExecutionFormProps<QuickConfirmConfig, QuickConfirmState>
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <QuickConfirmExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to QuickConfirmExecutionFormBase after feature is fully rolled out
  return <QuickConfirmExecutionFormBase {...props} />;
};
